<template>
  <div class="page-wrapper">
    <h1 class="title-screen">{{ adminText('workflowsAll.attendee_field_translations_e3bdaa4', 'Attendee field translations') }}</h1>
    <main-button
      class="button"
      @click="() => $emit('add')"
    >
      <img src="/assets/add.svg" :alt="adminText('workflowsAll.add_icon_42b71d9', 'add icon')" class="add-icon">
      {{ adminText('workflowsAll.add_translations_09271f9', 'ADD TRANSLATIONS') }}
    </main-button>
    <div v-for="(language, index) in this.initialValues" :key="index">
      <div class="language" @click="() => $emit('edit', language)">
        {{ workflowLabel(language) }}
      </div>
    </div>
  </div>
</template>

<script>
import WorkflowDisplay from '@/admin-i18n/workflows-all-display'
export default {
  mixins: [WorkflowDisplay],
  name: 'event-translation',
  props: {
    initialValues: {
      default: [],
      type: Array,
    },
    eventId: {
      default: null,
      type: String,
    },
  },
  data() {
    return {}
  },
}
</script>

<style scoped>
.add-icon {
  width: 0.75rem;
  height: 0.75rem;
  margin-right: 0.5rem;
}
.language {
  max-width: 500px;
  margin-bottom: 10px;
  cursor: pointer;
  background: #f5f5f5;
  border-radius: 10px;
  padding: 10px 16px;
}
.button {
  margin-bottom: 24px;
}
@media screen and (max-width: 800px) {
  .page-wrapper {
    margin-top: 1.5rem;
  }
}
</style>
